import { useEffect, useState } from 'react';
import { type Language, type Translations, getTranslations, getBrowserLanguage } from '@/lib/i18n';

const LANGUAGE_STORAGE_KEY = 'nodecast_language';

export function useTranslation() {
  const [language, setLanguageState] = useState<Language>(() => {
    // Try to get from localStorage first
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY) as Language | null;
    if (stored && (stored === 'en' || stored === 'es')) {
      return stored;
    }
    // Fall back to browser language
    return getBrowserLanguage();
  });

  const [t, setT] = useState<Translations>(() => getTranslations(language));

  useEffect(() => {
    setT(getTranslations(language));
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }, [language]);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
  };

  return { t, language, setLanguage };
}
